<template>
    <FinanceData/>
</template>

<script>
import { FinanceData } from 'shared'

export default {
    name: 'financeData',
    components: {
        FinanceData
    },
    data() {
        return {
            params: {
                // mohu: 'a103',
                a103: '私域电商'
            }
        }
    },
    created() {
        this.$store.dispatch('getFinancing2', this.params)
    },
}
</script>